<template>
  <div class="membership-manage">
    <el-card class="header-card">
      <div slot="header" class="clearfix">
        <span class="card-title">
          <i class="el-icon-trophy"></i> {{ pageTitle }}
        </span>
      </div>

      <!-- 统计卡片 -->
      <el-row :gutter="20" class="stats-row">
        <el-col :span="6">
          <div class="stat-card">
            <div class="stat-icon blue">
              <i class="el-icon-user"></i>
            </div>
            <div class="stat-info">
              <div class="stat-value">{{ statistics.totalMembers || 0 }}</div>
              <div class="stat-label">总会员数</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card">
            <div class="stat-icon orange">
              <i class="el-icon-medal"></i>
            </div>
            <div class="stat-info">
              <div class="stat-value">{{ statistics.premiumMembers || 0 }}</div>
              <div class="stat-label">高级会员</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card">
            <div class="stat-icon purple">
              <i class="el-icon-trophy"></i>
            </div>
            <div class="stat-info">
              <div class="stat-value">{{ statistics.professionalMembers || 0 }}</div>
              <div class="stat-label">专业会员</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card">
            <div class="stat-icon green">
              <i class="el-icon-money"></i>
            </div>
            <div class="stat-info">
              <div class="stat-value">¥{{ statistics.todayRevenue || 0 }}</div>
              <div class="stat-label">今日收入</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!-- 会员配置 -->
    <el-card class="config-card">
      <div slot="header">
        <span>会员等级配置</span>
      </div>

      <el-table :data="membershipConfigs" stripe size="small">
        <el-table-column prop="level" label="等级" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="getLevelType(scope.row.level)" size="small">
              {{ ['普通', '高级', '专业'][scope.row.level] }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="levelName" label="名称" width="100" />
        <el-table-column prop="status" label="状态" width="70" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'" size="mini">
              {{ scope.row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="dailyDownloadLimit" label="每日下载" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.dailyDownloadLimit === -1 ? '无限' : scope.row.dailyDownloadLimit }}
          </template>
        </el-table-column>
        <el-table-column label="权益" min-width="260">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.canAccessPremium" size="mini" type="success" effect="plain" class="benefit-tag">
              精品区
            </el-tag>
            <el-tag v-if="scope.row.hasAdFree" size="mini" type="success" effect="plain" class="benefit-tag">
              免广告
            </el-tag>
            <el-tag v-if="scope.row.canAccessSourceCode" size="mini" type="success" effect="plain" class="benefit-tag">
              源码库
            </el-tag>
            <el-tag v-if="scope.row.earlyAccessDays > 0" size="mini" type="warning" effect="plain" class="benefit-tag">
              提前{{ scope.row.earlyAccessDays }}天
            </el-tag>
            <el-tag v-if="scope.row.techSupportCount > 0" size="mini" type="primary" effect="plain" class="benefit-tag">
              支持×{{ scope.row.techSupportCount }}
            </el-tag>
            <!-- 添加资源代找次数显示 -->
            <el-tag v-if="scope.row.resourceFindCount > 0" size="mini" type="primary" effect="plain" class="benefit-tag">
              代找×{{ scope.row.resourceFindCount }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="价格" width="240">
          <template slot-scope="scope">
            <div v-if="scope.row.level > 0" class="price-info">
              月:¥{{ scope.row.monthPrice }} / 季:¥{{ scope.row.quarterPrice }} / 年:¥{{ scope.row.yearPrice }}
            </div>
            <span v-else class="text-muted">免费</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button 
              type="text" 
              size="small" 
              @click="handleToggleStatus(scope.row)"
              :class="scope.row.status === 1 ? 'text-danger' : 'text-success'">
              {{ scope.row.status === 1 ? '禁用' : '启用' }}
            </el-button>
            <el-button 
              type="text" 
              size="small" 
              @click="handleEditConfigRow(scope.row)">
              编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 会员列表 -->
    <el-card class="member-list-card">
      <div slot="header">
        <span>会员列表</span>
      </div>

      <!-- 搜索栏 -->
      <div class="search-bar">
        <el-row :gutter="12">
          <el-col :span="6">
            <el-input 
              v-model="searchForm.keyword" 
              placeholder="用户名/昵称"
              size="small"
              prefix-icon="el-icon-search"
              clearable
              @clear="loadMembers">
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-select v-model="searchForm.membershipLevel" placeholder="会员等级" size="small" clearable>
              <el-option label="全部" :value="null"></el-option>
              <el-option label="普通会员" :value="0"></el-option>
              <el-option label="高级会员" :value="1"></el-option>
              <el-option label="专业会员" :value="2"></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-select v-model="searchForm.status" placeholder="状态" size="small" clearable>
              <el-option label="全部" :value="null"></el-option>
              <el-option label="正常" value="normal"></el-option>
              <el-option label="即将过期" value="expiring"></el-option>
              <el-option label="已过期" value="expired"></el-option>
            </el-select>
          </el-col>
          <el-col :span="10">
            <el-button type="primary" size="small" @click="loadMembers">搜索</el-button>
            <el-button size="small" @click="handleReset">重置</el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 会员表格 -->
      <el-table 
        :data="memberList" 
        stripe
        size="medium"
        v-loading="loading"
        style="margin-top: 16px">
        <el-table-column prop="id" label="ID" width="70" align="center" />
        <el-table-column prop="username" label="用户名" width="110" />
        <el-table-column prop="nickname" label="昵称" width="110">
          <template slot-scope="scope">
            {{ scope.row.nickname || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="membershipLevel" label="会员等级" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getLevelType(scope.row.membershipLevel)" size="small">
              {{ ['普通', '高级', '专业'][scope.row.membershipLevel] }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="membershipExpireTime" label="到期时间" width="170">
          <template slot-scope="scope">
            <span v-if="scope.row.membershipExpireTime">
              {{ scope.row.membershipExpireTime }}
              <el-tag 
                v-if="isExpiringSoon(scope.row.membershipExpireTime)" 
                size="mini" 
                type="warning">
                即将过期
              </el-tag>
            </span>
            <span v-else class="text-muted">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="dailyDownloadCount" label="今日下载" width="90" align="center">
          <template slot-scope="scope">
            {{ scope.row.dailyDownloadCount || 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="注册时间" min-width="110">
          <template slot-scope="scope">
            {{ scope.row.createTime ? scope.row.createTime.substring(0, 10) : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button 
              type="text" 
              size="small" 
              @click="handleUpgrade(scope.row)">
              升级
            </el-button>
            <el-button 
              type="text" 
              size="small" 
              @click="handleExtend(scope.row)">
              续期
            </el-button>
            <el-button 
              type="text" 
              size="small" 
              @click="handleResetDownload(scope.row)">
              重置
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.size"
          :total="pagination.total"
          layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
    </el-card>

    <!-- 升级会员对话框 -->
    <el-dialog title="升级会员" :visible.sync="upgradeDialogVisible" width="500px">
      <el-form :model="upgradeForm" label-width="100px">
        <el-form-item label="用户">
          <span>{{ currentMember.username }} ({{ currentMember.nickname }})</span>
        </el-form-item>
        <el-form-item label="当前等级">
          <el-tag :type="getLevelType(currentMember.membershipLevel)">
            {{ ['普通会员', '高级会员', '专业会员'][currentMember.membershipLevel] }}
          </el-tag>
        </el-form-item>
        <el-form-item label="升级至">
          <el-select v-model="upgradeForm.level" placeholder="选择会员等级">
            <el-option 
              v-for="config in membershipConfigs.filter(c => c.level > currentMember.membershipLevel)" 
              :key="config.level" 
              :label="config.levelName" 
              :value="config.level">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="有效期">
          <el-select v-model="upgradeForm.durationType">
            <el-option label="1个月" value="monthly"></el-option>
            <el-option label="3个月（季付）" value="quarterly"></el-option>
            <el-option label="12个月（年付）" value="yearly"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="upgradeDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmUpgrade">确定</el-button>
      </div>
    </el-dialog>

    <!-- 续期对话框 -->
    <el-dialog title="续期会员" :visible.sync="extendDialogVisible" width="500px">
      <el-form :model="extendForm" label-width="100px">
        <el-form-item label="用户">
          <span>{{ currentMember.username }} ({{ currentMember.nickname }})</span>
        </el-form-item>
        <el-form-item label="当前等级">
          <el-tag :type="getLevelType(currentMember.membershipLevel)">
            {{ ['普通会员', '高级会员', '专业会员'][currentMember.membershipLevel] }}
          </el-tag>
        </el-form-item>
        <el-form-item label="当前到期时间">
          <span>{{ currentMember.membershipExpireTime || '无' }}</span>
        </el-form-item>
        <el-form-item label="续期时长">
          <el-select v-model="extendForm.durationType">
            <el-option label="1个月" value="monthly"></el-option>
            <el-option label="3个月（季付）" value="quarterly"></el-option>
            <el-option label="12个月（年付）" value="yearly"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="extendDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmExtend">确定</el-button>
      </div>
    </el-dialog>

    <!-- 会员配置编辑对话框 -->
    <el-dialog title="编辑会员配置" :visible.sync="configDialogVisible" width="700px">
      <el-form :model="configForm" :rules="configRules" ref="configForm" label-width="140px">
        <el-form-item label="会员等级">
          <el-tag :type="getLevelType(configForm.level)">
            {{ ['普通会员', '高级会员', '专业会员'][configForm.level] }}
          </el-tag>
        </el-form-item>
        
        <el-form-item label="等级名称" prop="levelName">
          <el-input v-model="configForm.levelName" placeholder="请输入等级名称"></el-input>
        </el-form-item>
        
        <el-form-item label="状态">
          <el-switch 
            v-model="configForm.status" 
            :active-value="1" 
            :inactive-value="0"
            active-text="启用"
            inactive-text="禁用">
          </el-switch>
        </el-form-item>
        
        <el-form-item label="每日下载限制" prop="dailyDownloadLimit">
          <el-input-number v-model="configForm.dailyDownloadLimit" :min="-1" :max="1000"></el-input-number>
          <span style="margin-left: 10px; color: #999;">-1 表示无限制</span>
        </el-form-item>
        
        <el-divider>权益配置</el-divider>
        
        <el-form-item label="精品专区访问">
          <el-switch v-model="configForm.canAccessPremium" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        
        <el-form-item label="源码库访问">
          <el-switch v-model="configForm.canAccessSourceCode" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        
        <el-form-item label="免广告">
          <el-switch v-model="configForm.hasAdFree" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
        
        <el-form-item label="新资源抢先体验">
          <el-input-number v-model="configForm.earlyAccessDays" :min="0" :max="30"></el-input-number>
          <span style="margin-left: 10px; color: #999;">天</span>
        </el-form-item>
        
        <el-form-item label="每月技术支持次数">
          <el-input-number v-model="configForm.techSupportCount" :min="0" :max="20"></el-input-number>
        </el-form-item>
        
        <!-- 添加资源代找次数配置项 -->
        <el-form-item label="每月资源代找次数">
          <el-input-number v-model="configForm.resourceFindCount" :min="0" :max="20"></el-input-number>
        </el-form-item>
        
        <el-divider v-if="configForm.level > 0">价格配置</el-divider>
        
        <el-form-item label="月费价格" prop="monthPrice" v-if="configForm.level > 0">
          <el-input-number v-model="configForm.monthPrice" :min="0" :max="999" :precision="2"></el-input-number>
          <span style="margin-left: 10px;">元</span>
        </el-form-item>
        
        <el-form-item label="季费价格" prop="quarterPrice" v-if="configForm.level > 0">
          <el-input-number v-model="configForm.quarterPrice" :min="0" :max="999" :precision="2"></el-input-number>
          <span style="margin-left: 10px;">元</span>
        </el-form-item>
        
        <el-form-item label="年费价格" prop="yearPrice" v-if="configForm.level > 0">
          <el-input-number v-model="configForm.yearPrice" :min="0" :max="9999" :precision="2"></el-input-number>
          <span style="margin-left: 10px;">元</span>
        </el-form-item>
        
        <el-form-item label="等级描述">
          <el-input 
            v-model="configForm.description" 
            type="textarea" 
            :rows="3" 
            placeholder="请输入等级描述"
            maxlength="200"
            show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="configDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmSaveConfig">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MembershipManage',
  data() {
    return {
      loading: false,
      statistics: {
        totalMembers: 0,
        premiumMembers: 0,
        professionalMembers: 0,
        todayRevenue: 0
      },
      membershipConfigs: [],
      memberList: [],
      searchForm: {
        keyword: '',
        membershipLevel: null,
        status: null
      },
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
      upgradeDialogVisible: false,
      extendDialogVisible: false,
      configDialogVisible: false,
      currentMember: {},
      upgradeForm: {
        level: null,
        durationType: 'monthly'
      },
      extendForm: {
        durationType: 'monthly'
      },
      configForm: {
        id: null,
        level: 0,
        levelName: '',
        dailyDownloadLimit: 0,
        canAccessPremium: 0,
        canAccessSourceCode: 0,
        hasAdFree: 0,
        earlyAccessDays: 0,
        techSupportCount: 0,
        // 添加资源代找次数字段
        resourceFindCount: 0,
        monthPrice: 0,
        quarterPrice: 0,
        yearPrice: 0,
        description: ''
      },
      configRules: {
        levelName: [
          { required: true, message: '请输入等级名称', trigger: 'blur' }
        ],
        dailyDownloadLimit: [
          { required: true, message: '请设置下载限制', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.loadStatistics()
    this.loadConfigs()
    this.loadMembers()
  },
  methods: {
    async loadStatistics() {
      try {
        const res = await this.$axios.get('/admin/membership/statistics')
        if (res.data.code === 200) {
          this.statistics = res.data.data
        }
      } catch (error) {
        console.error('加载统计数据失败:', error)
      }
    },

    async loadConfigs() {
      try {
        const res = await this.$axios.get('/admin/membership/configs')
        if (res.data.code === 200) {
          this.membershipConfigs = res.data.data
        }
      } catch (error) {
        this.$message.error('加载会员配置失败')
      }
    },

    async loadMembers() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.page,
          size: this.pagination.size,
          ...this.searchForm
        }
        const res = await this.$axios.get('/admin/membership/members', { params })
        if (res.data.code === 200) {
          this.memberList = res.data.data.records
          this.pagination.total = res.data.data.total
        }
      } catch (error) {
        this.$message.error('加载会员列表失败')
      } finally {
        this.loading = false
      }
    },

    handleReset() {
      this.searchForm = {
        keyword: '',
        membershipLevel: null,
        status: null
      }
      this.pagination.page = 1
      this.loadMembers()
    },

    handleSizeChange(size) {
      this.pagination.size = size
      this.pagination.page = 1
      this.loadMembers()
    },

    handleCurrentChange(page) {
      this.pagination.page = page
      this.loadMembers()
    },

    handleEditConfig() {
      this.$message.info('请点击具体等级后面的编辑按钮进行配置')
    },

    handleEditConfigRow(row) {
      this.configForm = {
        id: row.id,
        level: row.level,
        levelName: row.levelName,
        dailyDownloadLimit: row.dailyDownloadLimit,
        canAccessPremium: row.canAccessPremium || 0,
        canAccessSourceCode: row.canAccessSourceCode || 0,
        hasAdFree: row.hasAdFree || 0,
        earlyAccessDays: row.earlyAccessDays || 0,
        techSupportCount: row.techSupportCount || 0,
        // 添加资源代找次数字段
        resourceFindCount: row.resourceFindCount || 0,
        monthPrice: row.monthPrice || 0,
        quarterPrice: row.quarterPrice || 0,
        yearPrice: row.yearPrice || 0,
        description: row.description || '',
        status: row.status !== undefined ? row.status : 1
      }
      this.configDialogVisible = true
    },

    async handleToggleStatus(row) {
      const action = row.status === 1 ? '禁用' : '启用'
      try {
        await this.$confirm(`确定要${action}「${row.levelName}」吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const newStatus = row.status === 1 ? 0 : 1
        
        // 只发送必要的字段
        const updateData = {
          id: row.id,
          level: row.level,
          levelName: row.levelName,
          levelBadge: row.levelBadge,
          dailyDownloadLimit: row.dailyDownloadLimit,
          downloadSpeedLimit: row.downloadSpeedLimit,
          canAccessPremium: row.canAccessPremium,
          canAccessSourceCode: row.canAccessSourceCode,
          hasAdFree: row.hasAdFree,
          earlyAccessDays: row.earlyAccessDays,
          techSupportCount: row.techSupportCount,
          resourceFindCount: row.resourceFindCount,
          canPromote: row.canPromote,
          monthPrice: row.monthPrice,
          quarterPrice: row.quarterPrice,
          yearPrice: row.yearPrice,
          description: row.description,
          status: newStatus
        }
        
        const res = await this.$axios.put(`/admin/membership/config/${row.id}`, updateData)
        
        if (res.data.code === 200) {
          this.$message.success(`${action}成功`)
          this.loadConfigs()
        } else {
          this.$message.error(res.data.message || `${action}失败`)
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('Toggle status error:', error)
          this.$message.error(`${action}失败`)
        }
      }
    },

    async confirmSaveConfig() {
      this.$refs.configForm.validate(async (valid) => {
        if (!valid) {
          return false
        }

        try {
          const res = await this.$axios.put(`/admin/membership/config/${this.configForm.id}`, this.configForm)
          if (res.data.code === 200) {
            this.$message.success('配置保存成功')
            this.configDialogVisible = false
            this.loadConfigs()
          }
        } catch (error) {
          this.$message.error('配置保存失败')
        }
      })
    },

    handleUpgrade(row) {
      this.currentMember = { ...row }
      this.upgradeForm = {
        level: null,
        durationType: 'monthly'
      }
      this.upgradeDialogVisible = true
    },

    handleExtend(row) {
      this.currentMember = { ...row }
      this.extendForm = {
        durationType: 'monthly'
      }
      this.extendDialogVisible = true
    },

    async confirmUpgrade() {
      if (!this.upgradeForm.level) {
        this.$message.warning('请选择会员等级')
        return
      }

      try {
        const res = await this.$axios.post('/admin/membership/upgrade', {
          userId: this.currentMember.id,
          membershipLevel: this.upgradeForm.level,
          durationType: this.upgradeForm.durationType
        })
        if (res.data.code === 200) {
          this.$message.success('升级成功')
          this.upgradeDialogVisible = false
          this.loadMembers()
          this.loadStatistics()
        }
      } catch (error) {
        this.$message.error('升级失败')
      }
    },

    async confirmExtend() {
      try {
        const res = await this.$axios.post('/admin/membership/extend', {
          userId: this.currentMember.id,
          durationType: this.extendForm.durationType
        })
        if (res.data.code === 200) {
          this.$message.success('续期成功')
          this.extendDialogVisible = false
          this.loadMembers()
        }
      } catch (error) {
        this.$message.error('续期失败')
      }
    },

    async handleResetDownload(row) {
      try {
        const res = await this.$axios.post(`/admin/membership/reset-download/${row.id}`)
        if (res.data.code === 200) {
          this.$message.success('重置成功')
          this.loadMembers()
        }
      } catch (error) {
        this.$message.error('重置失败')
      }
    },

    getLevelType(level) {
      const types = ['info', 'warning', 'danger']
      return types[level] || 'info'
    },

    isExpiringSoon(expireTime) {
      if (!expireTime) return false
      const expire = new Date(expireTime)
      const now = new Date()
      const diff = expire - now
      const days = diff / (1000 * 60 * 60 * 24)
      return days > 0 && days <= 7
    }
  }
}
</script>

<style scoped>
.membership-manage {
  padding: 20px;
}

.card-title {
  font-size: 16px;
  font-weight: bold;
}

.stats-row {
  margin-top: 20px;
}

.stat-card {
  display: flex;
  align-items: center;
  padding: 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px;
  color: white;
}

.stat-card .stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  margin-right: 15px;
}

.stat-icon.blue {
  background: rgba(255, 255, 255, 0.2);
}

.stat-icon.orange {
  background: rgba(255, 152, 0, 0.3);
}

.stat-icon.purple {
  background: rgba(156, 39, 176, 0.3);
}

.stat-icon.green {
  background: rgba(76, 175, 80, 0.3);
}

.stat-info {
  flex: 1;
}

.stat-value {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 14px;
  opacity: 0.9;
}

.config-card {
  margin-top: 20px;
}

.member-list-card {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 480px);
  min-height: 500px;
}

.member-list-card >>> .el-card__body {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.member-list-card .el-table {
  flex: 1;
}

.benefit-tag {
  margin-right: 5px;
  margin-bottom: 5px;
}

.price-info {
  font-size: 13px;
  color: #606266;
}

.text-success {
  color: #67c23a;
  font-weight: 500;
}

.text-danger {
  color: #f56c6c;
}

.search-bar {
  margin-bottom: 10px;
}

.pagination-wrapper {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.text-muted {
  color: #909399;
}
</style>
